export default __webpack_public_path__ + "static/media/confirmation_number-24px.24e1fa43.svg";